import { Link, useLocation } from 'react-router-dom';

const WEDDING_HALL_MENUS = [
  { path: '/wedding-hall/customers', label: '고객관리', icon: 'ri-user-3-line' },
  { path: '/wedding-hall/schedules', label: '일정관리', icon: 'ri-calendar-check-line' },
  { path: '/wedding-hall/venue-grid', label: '홀현황', icon: 'ri-calendar-2-line' },
  { path: '/wedding-hall/settlements', label: '정산관리', icon: 'ri-exchange-line' },
  { path: '/wedding-hall/venues', label: '홀관리', icon: 'ri-building-4-line' },
];

export default function WeddingHallNav() {
  const location = useLocation();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/') ||
    (path === '/wedding-hall/customers' && location.pathname.startsWith('/wedding-hall/customer-detail'));

  return (
    <div className="bg-white border-b border-gray-200 mb-6 -mx-8 -mt-8 px-8 pt-4">
      <div className="flex items-center gap-1 mb-0">
        <span className="text-sm font-bold text-gray-800 mr-4">웨딩홀</span>
        {WEDDING_HALL_MENUS.map((menu) => (
          <Link
            key={menu.path}
            to={menu.path}
            className={`px-3 py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive(menu.path)
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300'
            }`}
          >
            <i className={`${menu.icon} mr-1.5`}></i>
            {menu.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
